import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-unregistered',
  templateUrl: './home-unregistered.component.html',
  styleUrls: ['./home-unregistered.component.scss'],
})
export class HomeUnregisteredComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
